import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import { http } from "../helper";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
import AlertPopup from "../common/alertPopup";
import { Trans } from "react-i18next";
const MODULE = "manage_emailcampaign";

const AutoEmailSettings = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit;
  const [autoSend_Scheduler, setAutoSend_Scheduler] = useState(false);
  const [autoSend_Scheduler_Text, setAutoSend_Scheduler_Text] = useState("");
  // const [promoDiscountPercentage, setPromoDiscountPercentage] = useState("");
  // const [promoEmailTriggerDays, setPromoEmailTriggerDays] = useState("");
  const [errormsg, setErrormsg] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const tabs = [
    { name: t("auto_email_tab_txt"), value: "auto_email_settings" },
    // { name: t("promocode_email_tab_txt"), value: "promocode_email_settings" },
    // { name: t("promo_code_settings_txt"), value: "promo_code_settings" },
  ];

  const [activeTab, setActiveTab] = useState("auto_email_settings");
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  const autoEmailSubTabs = [
    { name: t("logged_in_ordered_email_txt"), value: "loggedin_not_order" },
    { name: t("logged_in_ordered_email_cutoff_txt"), value: "loggedin_not_order_cutoff" },
    { name: t("abandoned_cart_email_txt"), value: "abandoned_cart" },
  ];
  const [activeAutoEmailSubTab, setActiveAutoEmailSubTab] = useState("loggedin_not_order");
  const [autoEmailSubTabFields, setAutoEmailSubTabFields] = useState({
    loggedin_not_order: { autoSend_Scheduler_Text: "", autoSend_Scheduler: false },
    loggedin_not_order_cutoff: { autoSend_Scheduler_Text: "", autoSend_Scheduler: false },
    abandoned_cart: { autoSend_Scheduler_Text: "", autoSend_Scheduler: false },
  });

  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    setIsLoading(true);

    Promise.all([
      http.get(BaseUrl + "admin/emailsettings"),
      //http.get(BaseUrl + "admin/promocodesetting"),
    ])
      .then(([emailRes, promoRes]) => {
        // ---- Email settings ----
        if (emailRes.data.success && emailRes.data.data?.length) {
          const data = emailRes.data.data[0];
          // setPromoEmailEnabled(Boolean(data.promoEmailEnabled));
          // setPromoDiscountPercentage(
          //   String(data.promoDiscountPercentage || "")
          // );
          // setPromoEmailTriggerDays(String(data.promoEmailTriggerDays || ""));
          // setIsExpiryEnabled(Boolean(data.isExpiryEnabled));
          // setExpiryDays(String(data.expiryDays || ""));
          // setPromoReminderLimit(String(data.promoReminderLimit || ""));
          // setPromoReminderEmailInterval(
          //   String(data.promoReminderEmailInterval || "")
          // );
          // setVatMode(data.vatMode || "");
          setAutoEmailSubTabFields({
            loggedin_not_order: {
              autoSend_Scheduler: Boolean(data.autoSendScheduler_loggedinNotOrder),
              autoSend_Scheduler_Text: String(
                data.autoEmailIntervalDays_loggedinNotOrder ?? ""
              ),
            },
            loggedin_not_order_cutoff: {
              autoSend_Scheduler: Boolean(
                data.autoSendScheduler_loggedinNotOrderCutoff
              ),
              autoSend_Scheduler_Text: String(
                data.autoEmailIntervalDays_loggedinNotOrderCutoff ?? ""
              ),
            },
            abandoned_cart: {
              autoSend_Scheduler: Boolean(data.autoSendScheduler_abandoned),
              autoSend_Scheduler_Text: String(
                data.autoEmailIntervalDays_abandoned ?? ""
              ),
            },
          });
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, []);

  const formvalidation = () => {
    let isValid = true;
    const tempErr = {};

    // Auto Email Settings Validation
    if (activeTab === "auto_email_settings") {
      const currentTabValue =
        autoEmailSubTabFields[activeAutoEmailSubTab]
          ?.autoSend_Scheduler_Text?.trim();
      if (!currentTabValue) {
        tempErr.autoEmailTextErr = t("field_require_txt");
        tempErr.autoemail = true;
        isValid = false;
      }
    }
    // else if (isNaN(num) || num <= 0) {
    //     tempErr.autoEmailTextErr = "Interval must be greater than 0";
    //     tempErr.autoemail = true;
    //     isValid = false;
    // }
    setErrMessage(tempErr);
    setErrormsg(tempErr);
    return isValid;
  };

  const btnsubmit = async (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    if (!formvalidation()) return;
    setIsLoading(true);

    const emailPayload = {
      // promoEmailEnabled,
      // promoDiscountPercentage: Number(promoDiscountPercentage),
      // promoEmailTriggerDays: Number(promoEmailTriggerDays),
      // promoReminderLimit: Number(promoReminderLimit),
      // promoReminderEmailInterval: Number(promoReminderEmailInterval),
      // isExpiryEnabled,
      // expiryDays: Number(expiryDays),
      // vatMode,
      // renamed fields per sub-tab
      autoSendScheduler_loggedinNotOrder: autoEmailSubTabFields.loggedin_not_order.autoSend_Scheduler,
      autoEmailIntervalDays_loggedinNotOrder: Number(autoEmailSubTabFields.loggedin_not_order.autoSend_Scheduler_Text),
      autoSendScheduler_loggedinNotOrderCutoff: autoEmailSubTabFields.loggedin_not_order_cutoff.autoSend_Scheduler,
      autoEmailIntervalDays_loggedinNotOrderCutoff: Number(autoEmailSubTabFields.loggedin_not_order_cutoff.autoSend_Scheduler_Text),
      autoSendScheduler_abandoned: autoEmailSubTabFields.abandoned_cart.autoSend_Scheduler,
      autoEmailIntervalDays_abandoned: Number(autoEmailSubTabFields.abandoned_cart.autoSend_Scheduler_Text),
    };

    // const promoPayload = {
    //   offer_txt: offerTxt.trim(),
    //   enablenotification: enablePromo,
    //   bar_message: barMessage.trim(),
    //   cart_message: cartMessage.trim(),
    //   checkout_popup_message: checkPopupMessage.trim(),
    //   thankyou_page_message: thankYouMessage.trim(),
    // };

    try {
      await Promise.all([
        http.post(BaseUrl + "admin/emailsettings", emailPayload),
        //http.post(BaseUrl + "admin/promocodesetting", promoPayload),
      ]);

      setAlertPopup(true);
      setAlertMessage(t("setting_saved_successfully_txt"));
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnChange = (e) => {
    const { name, value, checked } = e.target;
    const re = /^[0-9\b]+$/;
    if (name === "autoSendScheduler") {
      setAutoSend_Scheduler(checked);
    }
    if (name === "autoEmailText") {
      if (value === "" || re.test(value)) {
        setAutoSend_Scheduler_Text(value);
        setErrMessage({ ...errmessage, autoEmailTextErr: "" });
        setErrormsg({ ...errormsg, autoemail: false });
      }
    }
    // if (name === "promoDiscountPercentage") {
    //   if (value === "" || re.test(value)) {
    //     setPromoDiscountPercentage(value);
    //     setErrMessage({ ...errmessage, promoDiscountPercentage: "" });
    //     // setErrormsg({ ...errormsg, autoemail: false });
    //   }
    // }
    // if (name === "promoEmailTriggerDays") {
    //   if (value === "" || re.test(value)) {
    //     setPromoEmailTriggerDays(value);
    //     setErrMessage({ ...errmessage, promoEmailTriggerDays: "" });
    //     // setErrormsg({ ...errormsg, autoemail: false });
    //   }
    // }
    setAlertPopup(false);
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <AlertPopup
          title="Alert"
          message={alertMessage}
          handleOk={() => setAlertPopup(false)}
        />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("auto_email_settings_txt")}</h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <div className="form-field freeproduct-fieldset email-camp-set-fieldset">
                  <div className="header-tab-menu">
                    {tabs.map((tab) => (
                      <a
                        key={tab.name}
                        className={activeTab === tab.value ? "active" : ""}
                        onClick={() => setActiveTab(tab.value)}
                      >
                        {tab.name}
                      </a>
                    ))}
                  </div>

                  <form className="client-detail-form">
                    {activeTab === "auto_email_settings" && (
                      <>
                        <div className="header-tab-menu header-tab-subs">
                          <div className="subtab-menu">
                            {autoEmailSubTabs.map((tab) => (
                              <a
                                key={tab.value}
                                className={activeAutoEmailSubTab === tab.value ? "active" : ""}
                                onClick={() => {
                                  setActiveAutoEmailSubTab(tab.value);
                                  setErrormsg({});
                                  setErrMessage({});
                                }}
                              >
                                {tab.name}
                              </a>
                            ))}
                          </div>
                        </div>
                        <div className="input-field col-1">
                          <label>
                            {t("autoemail_interval_days_txt")}
                            <a
                              className="title-tooltip title-right switch-info w--tp-xl"
                              data-title={t("interval_info_txt")}
                            >
                              <i className="fa fa-info-circle" aria-hidden="true"></i>
                            </a>
                          </label>
                          <input
                            type="text"
                            value={autoEmailSubTabFields[activeAutoEmailSubTab].autoSend_Scheduler_Text}
                            onChange={(e) => {
                              const value = e.target.value;
                              const re = /^[0-9\b]+$/;
                              if (value === "" || re.test(value)) {
                              setAutoEmailSubTabFields({
                                ...autoEmailSubTabFields,
                                [activeAutoEmailSubTab]: {
                                  ...autoEmailSubTabFields[activeAutoEmailSubTab],
                                  autoSend_Scheduler_Text: e.target.value,
                                },
                              });
                              setErrormsg((prev) => ({ ...prev, autoemail: false }));
                              setErrMessage((prev) => ({ ...prev, autoEmailTextErr: "" }));
                            }
                          }}
                            readOnly={isReadOnly}
                            placeholder={t("enter_interval_days_txt")}
                          />
                          {errormsg.autoemail && (
                            <div className="error-msg">
                              {errmessage.autoEmailTextErr}
                            </div>
                          )}
                        </div>
                        <div className="input-field col-1">
                          <label>
                            {t("autoemail_scheduler_manual")}
                            <a
                              className="title-tooltip title-right switch-info w--tp-xl"
                              data-title={t("autoemail_toggle_infop_txt")}
                            >
                              <i className="fa fa-info-circle" aria-hidden="true"></i>
                            </a>
                          </label>
                          <div className="switch-button">
                            <input
                              type="checkbox"
                              className="checkbox"
                              checked={autoEmailSubTabFields[activeAutoEmailSubTab].autoSend_Scheduler}
                              disabled={isReadOnly}
                              onChange={(e) =>
                                setAutoEmailSubTabFields({
                                  ...autoEmailSubTabFields,
                                  [activeAutoEmailSubTab]: {
                                    ...autoEmailSubTabFields[activeAutoEmailSubTab],
                                    autoSend_Scheduler: e.target.checked,
                                  },
                                })
                              }
                            />
                            <div className="knobs">
                              <span></span>
                            </div>
                            <div className="layer"></div>
                          </div>
                        </div>
                      </>
                    )}
                    
                    <div className="btnfield">
                      {!isReadOnly && (
                        <button type="submit" onClick={btnsubmit}>
                          {t("submit_txt")}
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default AutoEmailSettings;
